import "./App.css";
import { useState, useEffect, useCallback } from "react";
import SingleCard from "./components/SingleCard";

const cardImages = [
  { src: "/images/helmet-1.png" },
  { src: "/images/potion-1.png" },
  { src: "/images/ring-1.png" },
  { src: "/images/scroll-1.png" },
  { src: "/images/shield-1.png" },
  { src: "/images/sword-1.png" },
];

function App() {
  const [cards, setCards] = useState([]);
  const [choiceOne, setChoiceOne] = useState(null);
  const [choiceTwo, setChoiceTwo] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [turns, setTurns] = useState(0);
  const [finish, setFinish] = useState(false);
  const handleNewGame = useCallback(() => {
    setTurns(0);
    setFinish(false);
    // 카드 뒤집기
    resetTurn();
    setCards((cards) =>
      cards.map((card) => ({
        ...card,
        matched: false,
      }))
    );
    setTimeout(suffleCards, 1000);
  }, []);
  // game start
  useEffect(() => {
    suffleCards();
  }, [handleNewGame]);

  // match check
  useEffect(() => {
    if (choiceOne && choiceTwo) {
      setDisabled(true);
      if (choiceOne.src === choiceTwo.src) {
        setCards((prev) => {
          return prev.map((card) => {
            if (card.id === choiceOne.id || card.id === choiceTwo.id) {
              return { ...card, matched: true };
            } else {
              return card;
            }
          });
        });
        resetTurn();
      } else {
        setTimeout(() => {
          resetTurn();
        }, 1000);
      }
    }
  }, [choiceOne, choiceTwo]);

  const resetTurn = () => {
    setChoiceOne(null);
    setChoiceTwo(null);
    setTurns((prevTurns) => prevTurns + 1);
    setDisabled(false);
  };

  const handleChoice = (card) => {
    if (choiceOne) {
      if (choiceOne.id === card.id) return;
      setChoiceTwo(card);
    } else {
      setChoiceOne(card);
    }
  };
  const suffleCards = () => {
    const suffledCards = [...cardImages, ...cardImages]
      .sort(() => Math.random() - 0.5)
      .map((card, idx) => ({ ...card, id: idx, matched: false }));
    setCards(suffledCards);
  };

  useEffect(() => {
    if (cards.length === 0) return;
    cards.every((card) => card.matched) && setFinish(true);
  }, [cards]);

  return (
    <div className="App">
      <h1>Memory Game</h1>
      <p>{finish && <h1>You Win! {turns}회</h1>}</p>
      <button onClick={handleNewGame}>New Game</button>
      <div className="card-grid">
        {cards.map((card) => {
          return (
            <SingleCard
              card={card}
              key={card.id}
              handleChoice={handleChoice}
              disabled={disabled}
              flipped={card === choiceOne || card === choiceTwo || card.matched}
            />
          );
        })}
      </div>
      <p>Turns: {turns}</p>
    </div>
  );
}

export default App;
